
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player, playerId, videoLink, videoLinkId;

function onYouTubeIframeAPIReady(playerId, videoLinkId) {


  $(".video__player").each(function () {
    playerId = $(this).attr("id");


    videoLink = $("#" + playerId).attr("data-video-src");
    videoLinkId = videoLink.split("v=")[1];

    player = new YT.Player(playerId, {
      videoId: videoLinkId,
      playerVars: {
        mute: 1, //Must do this. otherwise wont autoplay on Chrome.
        autoplay: 1,
        controls: 0,
        autohide: 1,
        wmode: "opaque",
        showinfo: 0,
        loop: 1,
        rel: 0,
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': function(e) {
            if (e.data === YT.PlayerState.ENDED) {
                player.playVideo(); 
            }
        }
      }
    });

    player.setSize('100%', '100%')

    function onPlayerReady(event) {
      event.target.mute();
      event.target.playVideo();
    }

    

  })
}












